module.exports = __webpack_public_path__ + "static/media/header-img.35aecc1c.jpg";